import { ReactNode } from 'react';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

export function TotemPopup({
    title,
    children,
    isOpen,
    setIsOpen,
    contentOverflow,
}: {
    title: string;
    children: ReactNode;
    isOpen: boolean;
    setIsOpen: (arg: boolean) => void;
    contentOverflow?: string;
}) {
    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogContent className="sm:max-w-[95%] max-h-[95%] inline-flex flex-col">
                <DialogHeader>
                    <DialogTitle className="text-[26px] font-extrabold">{title}</DialogTitle>
                </DialogHeader>
                <div
                    className={cn(
                        'flex flex-col text-foreground mt-2.5',
                        contentOverflow === 'auto' && 'overflow-auto',
                        contentOverflow === 'scroll' && 'overflow-scroll',
                        contentOverflow === 'visible' && 'overflow-visible',
                        !contentOverflow && 'overflow-hidden',
                    )}
                >
                    {children}
                </div>
            </DialogContent>
        </Dialog>
    );
}
